var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1675.000000, -283.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-test",
    transform: "translate(1675.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.83333333,
    cy: 10.5,
    r: 1.16666667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.77777778,
    cy: 8.55555556,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.88888889,
    y: 0,
    width: 6.22222222,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6647778,11.4908889 L9.33333333,5.44444444 L9.33333333,0 L4.66666667,0 L4.66666667,5.44444444 L0.335222222,11.4908889 C0.128333333,11.7545556 0,12.0827778 0,12.4444444 C0,13.3038889 0.696111111,14 1.55555556,14 C2.023,14 11.977,14 12.4444444,14 C13.3038889,14 14,13.3038889 14,12.4444444 C14,12.0827778 13.8716667,11.7545556 13.6647778,11.4908889 Z M1.56022222,12.4498889 L1.58044444,12.4234444 L1.59988889,12.3962222 L6.22222222,5.94377778 L6.22222222,1.55555556 L7.77777778,1.55555556 L7.77777778,5.94377778 L12.4001111,12.3962222 L12.4234444,12.418 L12.4444444,12.4444444 L1.56022222,12.4498889 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5.44444444,
    y: 4.66666667,
    width: 3.11111111,
    height: 1.55555556
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTest);
export default __webpack_public_path__ + "static/media/icon-test.94b79b483ac328d24e73211b15fec404.svg";
export { ForwardRef as ReactComponent };